module.exports = __webpack_public_path__ + "img/menu_kagechi.5cb943a9.png";